import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
    return (
        <div className="container mt-5">
            {/* Two-Column Layout */}
            <div className="row align-items-center">
                {/* Image Column */}
                <div className="col-lg-6 text-center">
                    <img
                        src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736005518/task_management___balance_balancing_unicycle_shapes_woman_people_tasks_gw2fm2.png"
                        alt="About Us"
                        className="img-fluid mb-4"
                        style={{ width: '80%', maxWidth: '400px', height: 'auto', borderRadius: '10px' }}
                    />
                </div>

                {/* Content Column */}
                <div className="col-lg-6">
                    <h2 className='fw-bold text-center mb-3'>About Jessster</h2>
                    <p>
                        Jessster is a home for funny, thoughtful writing about absolutely anything. 
                    </p>
                    <p>
                        Some posts are silly. Some are smart. Some start out serious and take an unexpected left turn. The only real rule is that they’re written to be enjoyed — not skimmed, not optimized, and definitely not taken too seriously.
                    </p>
                    <p>
                        Jessster isn’t trying to break news or fix the world. It exists to explore ideas, moments, and observations through humor, wit, and the occasional well placed image or video that makes the joke land even harder.
                    </p>
                    <p>
                        Alongside the main Jessster posts, you’ll also find work from other Jesssters — community members who’ve submitted their own writing and earned a spot by being genuinely funny. 
                    </p>
                    <p>
                        If you enjoy clever humor, random thoughts, and writing that respects your intelligence, you’ll feel right at home here.
                    </p>
                    <p>
                        Welcome to Jessster. 🎉 😊
                    </p>
                    {/*
                    <Link to="/" className="btn btn-primary btn-lg">
                        Donate
                    </Link>
                    */}
                </div>
            </div>

            {/* Yellow Banner */}
            <div
                className="mt-5 p-5 text-center mx-auto"
                style={{
                    backgroundColor: '#f9c74f',
                    borderRadius: '10px',
                    color: '#000',
                    maxWidth: '900px',
                }}
            >
                <h3 className="fw-bold mb-3">Enjoying Jessster?</h3>
                <p className="mb-4">
                    If you like the writing and want to support what’s being built here, you can help keep Jessster going.
                </p>
                <Link to="/donate" className="btn btn-dark btn-lg fw-bold">
                    Show Some Love
                </Link>
            </div>
        </div>
    );
};

export default About;
